import React, { useEffect, useState } from 'react'
import ChatMenuHeader from './header'
import * as componentActions from '../../../../redux/actions/chats' // trocar pelo redux que criarei no chat
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Styles } from '../../../../styles/material-styles'
import { withRouter } from 'react-router-dom'
import { withStyles } from '@mui/styles'
import ChatHeader from './header'
import ChatConversations from './conversations'
import ChatSendBar from './send-bar'
import './styles.css'
import { PapiroConsole } from '../../../../utils/papiroConsole'

function Chat(props) {

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 599.9);

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 599.9);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (<div className="omnichannel-chat" style={{ width: '100%' }}>
    
      <ChatHeader changeSelect={props.changeSelect} customerid={props.customerid}
        customerList={props.customerList}
        loadingcustomerid={props.loadingcustomerid}
        isGlobalAdm = {props.isGlobalAdm}

        statusList={props.statusList} newStatusValue={props.newStatusValue} openOrCloseEndChatModal={props.openOrCloseEndChatModal} openOrCloseTransferChatModal={props.openOrCloseTransferChatModal} />

      

    <ChatConversations setLoading={props.setLoading} reSendMessage={props.reSendMessage} />
    {/* <ChatSendBar  phonenumberid={props.phonenumberid} sendMessage={props.sendMessage} sendMessageAttachment={props.sendMessageAttachment}
            setNotificationMessage={props.setNotificationMessage}
            setNotificationVariant={props.setNotificationVariant}
            setOpenNotification={props.setOpenNotification}
            customerid={props.customerid} 
/>*/}
  </div>)
}

Chat.propTypes = {
  classes: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  headerMenu: state.headerMenu,
  userSession: state.userSession,
  chats: state.chats
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(componentActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(Chat)))